
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/terms",
      function () {
        return require("private-next-pages/info/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/terms"])
      });
    }
  